<template>
  <div>
    <div class="row">
      <div class="col-10">
        <ContactSummaryWidget :filter="filter" :gridHeight="250" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="250">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/pricing/customerpricing#tab-pricereport">Customer Pricing Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/pricing/customerpricing#tab-priceoverridereport">Price List Overrides Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/contacts/people#tab-contact-people">Customer Persons Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ContactMinSpendWidget :filter="filter" :gridHeight="500" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ContactOrdersVariationWidget :filter="filter" :gridHeight="600" />
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import ContactSummaryWidget from '@/modules/intelligence/dashboardWidgets/contactSummaryWidget'
import ContactMinSpendWidget from '@/modules/intelligence/dashboardWidgets/contactMinSpendWidget'
import ContactOrdersVariationWidget from '@/modules/intelligence/dashboardWidgets/contactOrdersVariationWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsContactDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    ContactSummaryWidget,
    ContactMinSpendWidget,
    ContactOrdersVariationWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  props: {
    filter: Object
  },
  data() {
    return {
      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>